var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBroadcastTower, faClock, faEdit, faHourglassHalf, faInfoCircle, faTrash, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BCol, BInputGroup, BRow } from "bootstrap-vue";
import { computed } from "vue";
import { useConfirmDialog } from "@/composables/confirmDialog";
import { useMarkdown } from "@/composables/markdown";
import {} from "@/stores/broadcastsStore";
import Heading from "@/components/Common/Heading.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BroadcastCard',
    props: {
        broadcastNotification: null
    },
    emits: ["edit", "expire", "go-to-link"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faBroadcastTower, faClock, faEdit, faHourglassHalf, faInfoCircle, faTrash);
        const { confirm } = useConfirmDialog();
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const notification = computed(() => props.broadcastNotification);
        const hasExpired = computed(() => {
            return notification.value.expiration_time && new Date(notification.value.expiration_time) < new Date();
        });
        const hasBeenPublished = computed(() => {
            return new Date(notification.value.publication_time) < new Date();
        });
        const notificationVariant = computed(() => {
            switch (notification.value.variant) {
                case "urgent":
                    return "danger";
                default:
                    return notification.value.variant;
            }
        });
        const publicationTimePrefix = computed(() => {
            if (hasBeenPublished.value) {
                return "Published";
            }
            return "Scheduled to be published";
        });
        const expirationTimePrefix = computed(() => {
            if (notification.value.expiration_time) {
                if (hasExpired.value) {
                    return "Expired";
                }
                return "Expires";
            }
            return "Does not expire";
        });
        function onEditClick() {
            emit("edit", notification.value);
        }
        function onForceExpirationClick() {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm("Are you sure you want to expire this broadcast? It will be automatically deleted on the next cleanup cycle.", "Expire broadcast");
                if (confirmed) {
                    emit("expire", notification.value);
                }
            });
        }
        function onActionClick(link) {
            emit("go-to-link", link);
        }
        return { __sfc: true, confirm, renderMarkdown, props, emit, notification, hasExpired, hasBeenPublished, notificationVariant, publicationTimePrefix, expirationTimePrefix, onEditClick, onForceExpirationClick, onActionClick, faBroadcastTower, faClock, faEdit, faHourglassHalf, faInfoCircle, faTrash, FontAwesomeIcon, BButton, BCol, BInputGroup, BRow, Heading, UtcDate };
    }
});
